/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Open_Main_MenuInputs */

const en_nav_open_main_menu = /** @type {(inputs: Nav_Open_Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open main menu`)
};

const fr_nav_open_main_menu = /** @type {(inputs: Nav_Open_Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir le menu principal`)
};

/**
* | output |
* | --- |
* | "Open main menu" |
*
* @param {Nav_Open_Main_MenuInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const nav_open_main_menu = /** @type {((inputs?: Nav_Open_Main_MenuInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Open_Main_MenuInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_open_main_menu(inputs)
	return fr_nav_open_main_menu(inputs)
});